const MAX_LOGO_DIMENSION = 384;
const RESIZED_LOGO_TYPE = "image/png";
const RESIZED_LOGO_QUALITY = 0.92;

export const resizeLogoSource = (source) => new Promise((resolve, reject) => {
    if (!source) {
        reject(new Error("No logo image was provided."));
        return;
    }

    const image = new Image();

    image.onload = () => {
        const width = image.naturalWidth || image.width;
        const height = image.naturalHeight || image.height;

        if (!width || !height) {
            reject(new Error("The selected logo image could not be read."));
            return;
        }

        const scale = Math.min(1, MAX_LOGO_DIMENSION / Math.max(width, height));
        const targetWidth = Math.max(1, Math.round(width * scale));
        const targetHeight = Math.max(1, Math.round(height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const context = canvas.getContext("2d");
        if (!context) {
            reject(new Error("The logo could not be optimized in this browser."));
            return;
        }

        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = "high";
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        resolve(canvas.toDataURL(RESIZED_LOGO_TYPE, RESIZED_LOGO_QUALITY));
    };

    image.onerror = () => reject(new Error("The selected logo image could not be loaded."));
    image.src = source;
});

export const resizeLogoFile = (file) => new Promise((resolve, reject) => {
    if (!file?.type?.startsWith("image/")) {
        reject(new Error("Please upload a valid image file."));
        return;
    }

    const objectUrl = URL.createObjectURL(file);

    resizeLogoSource(objectUrl)
        .then(resolve)
        .catch(reject)
        .finally(() => URL.revokeObjectURL(objectUrl));
});
